export default {
  dateInput: {
    '&:first-child': {
      marginRight: '1rem',
    },
  },
};
